// extracted by mini-css-extract-plugin
export default {"input":"input--wdV1C"};